import { render, staticRenderFns } from "./GoogleAddressAutocomplete.vue?vue&type=template&id=8aaceb4c&scoped=true"
import script from "./GoogleAddressAutocomplete.vue?vue&type=script&lang=js"
export * from "./GoogleAddressAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./GoogleAddressAutocomplete.vue?vue&type=style&index=0&id=8aaceb4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aaceb4c",
  null
  
)

export default component.exports